
/**
 * @description: This class adds the ability to create mxml skin with file input type element.
 * package: com.inq.ui
 * class: FileInput
 * @constructor
 */
com.inq.ui.FileInput = function(id) {
	com.inq.ui.Container.call(this,id);
	this._div.innerHTML = "<input id='uploadInput' name='file' type='file' style=\"position:absolute;left:-9999px;\"/>";
	this.input = this._div.getElementsByTagName('input')[0];
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.FileInput, "com.inq.ui.FileInput");

/**
 * @override
 * @private
 * @return {void}
 */

com.inq.ui.FileInput.prototype.buildStyle = function() {
	com.inq.ui.Container.prototype.buildStyle.call(this);

};

/**
 * applying style to the html label element because user sees the html label element as input is moved left very far (see above input code)
 * @override
 * @private
 * @return {void}
 */
com.inq.ui.FileInput.prototype.applyStyle = function() {
	com.inq.ui.Container.prototype.applyStyle.call(this); /* Super call */
	/**
	 * @type {HTMLLabelElement}
	 */
	var htmlLabel = this._htmlLabel;
	if (htmlLabel) {
		htmlLabel.style.position = "";
		htmlLabel.style.left = "";
		htmlLabel.style.display="inline-block";
		htmlLabel.style.width="100%";
		htmlLabel.style.height="100%";
	}

};

/**
 * @type {HTMLInputElement}
 */
com.inq.ui.FileInput.prototype.input = null;